import { Component, OnInit } from '@angular/core';
import { UsuarioUnidade } from 'src/app/models/usuario-unidade';
import { FormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';
import { UtilValidators } from 'src/app/utils/util-validators';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalMsgService } from 'src/app/services/modal-msg.service';
import { UnidadeService } from 'src/app/services/http/unidade.service';
import { ConsultaService } from 'src/app/services/http/consulta.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalJustificativaComponent } from 'src/app/app-components/modal-justificativa/modal-justificativa.component';
import { LoginService } from 'src/app/services/login.service';
import { first } from 'rxjs/operators';
import { UsuarioService } from 'src/app/services/http/usuario.service';
import { UserConfigsUtils } from 'src/app/utils/UserConfigsUtils';

@Component({
  selector: 'app-form-usuario',
  templateUrl: './form-usuario.component.html',
  styleUrls: ['./form-usuario.component.scss']
})
export class FormUsuarioComponent implements OnInit {

  usuario = new UsuarioUnidade([]);
  form: FormGroup = new FormGroup({
    nome: new FormControl('', [Validators.required, Validators.required]),
    email: new FormControl('', [Validators.email]),
    login: new FormControl({ value: '' }, Validators.required),
    senha: new FormControl({ value: '' }, Validators.required),
    emailConf: new FormControl('', [UtilValidators.equalValidator('email')]),
    senhaConf: new FormControl('', [UtilValidators.equalValidator('senha')]),
  });
  uuid = null;
  uuidUnidade = null;
  login = null;
  unidade: boolean = false;
  checked: any;
  checkedConsultas: any;
  checkedPermissoes: any;
  disabledConsultas: any;
  disabledPermissoes: any;
  userAlreadyExist: boolean = false;
  desativarInputsEBotoes: boolean = false;

  constructor(
    private loginService: LoginService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalMsgService: ModalMsgService,
    private unidadeService: UnidadeService,
    private usuarioService: UsuarioService,
    private consultaService: ConsultaService,
    private modalService: NgbModal) {

    this.uuid = this.activatedRoute.snapshot.params.uuid || null;
    this.uuidUnidade = this.activatedRoute.snapshot.params.uuidUnidade || null;
    this.unidade = this.activatedRoute.snapshot.data['unidade'];
    let variavelDesativarInputsEBotoes;
    try {
      if (this.activatedRoute.snapshot.data['desativarInputsEBotoes'] === true) {
        this.desativarInputsEBotoes = this.activatedRoute.snapshot.data['desativarInputsEBotoes'];
      }
    } catch (e) {
      console.log(e.stack);
    }



    if (!this.uuidUnidade)
      this.loginService.getLogIn().pipe(first()).subscribe(l => {
        this.login = l;
        this.uuidUnidade = l.unidade.uuid;
      });

    if (this.uuid != null) {
      this.usuarioService.getUsuario(this.uuid).then(u => {

        this.usuario = u;
        this.form.patchValue({ ...u, emailConf: u.email });

        this.form.removeControl('senha');
        this.form.removeControl('senhaConf');

        let totalConsultas = u.listaConsultas;
        let totalConsultasChecked = u.listaConsultas.filter(c => c.checked);

        if (totalConsultasChecked.length == totalConsultas.length) {
          this.checkedConsultas = true;
          this.disabledConsultas = true;
        }

        let totalPermissoes = u.listaPermissao;
        let totalPermissoesChecked = u.listaPermissao.filter(c => c.checked);

        if (totalPermissoesChecked.length == totalPermissoes.length) {
          this.checkedPermissoes = true;
          this.disabledPermissoes = true;
        }

      });
    } else {
      this.unidadeService.getUnidade(this.uuidUnidade, [], true).then(c => {
        this.usuario.listaConsultas = c.unidade.listaConsultas.filter(c => c.checked == true).map(c => ({ ...c, checked: false }));
        this.usuario.listaConsultasCombinadas = c.unidade.listaConsultasCombinadas.map(r => ({ ...r, checked: false }));
      });

      this.unidadeService.getListaPermissaoUsuario().then(p => this.usuario.listaPermissao = p);

      this.form.controls.login = new FormControl({ value: '' }, Validators.required);
      this.form.controls.senha = new FormControl({ value: '' }, Validators.required);
    }

    this.form = new FormGroup({
      nome: new FormControl('', Validators.required),
      email: new FormControl('', [Validators.email]),
      login: new FormControl({ value: '', disabled: this.uuid != null }, Validators.required),
      senha: new FormControl({ value: '', disabled: false }, [
        Validators.required, 
        UtilValidators.senhaComCaracterEspecial,
        UtilValidators.senhaComMaiuscula,
        UtilValidators.senhaComMinuscula,
        UtilValidators.senhaComNumero,
        Validators.minLength(8),
        Validators.maxLength(100)
      ]),
      emailConf: new FormControl('', [Validators.required, UtilValidators.equalValidator('email')]),
      senhaConf: new FormControl('', [Validators.required, UtilValidators.equalValidator('senha')]),
    });

  }

  ngOnInit() {
  }

  checkedChangeAutorizacao(event) {
    if (event == true) {
      this.usuario.listaPermissao.map(c => c.checked = true);
      this.disabledPermissoes = true;
    } else {
      this.usuario.listaPermissao.map(c => c.checked = false);
      this.disabledPermissoes = false;
    }
  }


  checkedChangeConsultas(event) {
    if (event == true) {
      this.usuario.listaConsultas.map(c => c.checked = true);
      this.disabledConsultas = true;
    } else {
      this.usuario.listaConsultas.map(c => c.checked = false);
      this.disabledConsultas = false;
    }

  }

  request(justificativa) {
    if (this.uuid && !this.unidade)
      return this.usuarioService.editarUsuario({
        ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
        ...this.usuario,
        ...this.form.value,
      }, justificativa)

    if (this.uuid)
      return this.usuarioService.editarUsuarioUnidade({
        ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
        uuidUnidade: this.uuidUnidade,
        usuario: { ...this.usuario, ...this.form.value, uuidUnidade: this.uuidUnidade }
      }, justificativa);


    //criar usuario unidade
    if (!this.uuid && this.unidade)
      return this.usuarioService.adicionarUsuarioUnidade({
        ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
        uuidUnidade: this.uuidUnidade,
        usuario: { ...this.usuario, ...this.form.value, }
      }, justificativa)

    if (!this.uuid && !this.unidade)
      return this.usuarioService.adicionarUsuario({
        ip: UserConfigsUtils?.getUserConfigsStorage()?.ip || "",
        ...this.usuario,
        ...this.form.value,
      }, justificativa);


  }

  sendForm() {
    if (this.form.invalid) {
      this.modalMsgService.openDialog('Formulário inválido', 'Preencha todos os campos corretamente', 'danger');
      Object.keys(this.form.controls).forEach(c => this.form.get(c).markAsTouched());
      return;
    }

    const modalRef = this.modalService.open(ModalJustificativaComponent, { centered: true });
    modalRef.componentInstance.cabecalho = this.uuid ? 'Alterar usuario' : 'Novo usuario';
    modalRef.result.then(justificativa => {
      if (justificativa) {
        this.request(justificativa)
          .then(r => this.router.navigate([this.unidade ? 'unidade' : null, 'usuario', 'listar'].filter(f => f)))
          .catch(e => this.modalMsgService.openDialog('Erro ao ' + (this.uuid ? 'alterar' : 'cadastrar') + ' usuário',
            (e.error.error != undefined ? e.error.error : 'Verifique se todos os campos foram preenchidos corretamente'), 'danger'));
      } else {
        this.modalMsgService.openDialog('Erro ao ' + (this.uuid ? 'alterar' : 'cadastrar') + ' usuário',
          'Informe uma Justificativa para concluir a operação', 'danger');
      }
    }).catch(e => this.modalMsgService.openDialog('Erro ao ' + (this.uuid ? 'alterar' : 'cadastrar') + ' usuário',
      'Informe uma Justificativa para concluir a operação', 'danger'));
  }

  existUser() {
    if (this.uuid == null && this.form.controls.login.value != null) {
      var usuario: UsuarioUnidade = new UsuarioUnidade([]);
      this.usuarioService.getUsuarioByLogin(this.form.controls.login.value)
        .then(u => {
          usuario = u;
          if (usuario.uuid == null) {
            this.userAlreadyExist = false
          }
          else {
            this.userAlreadyExist = true
          }
        }).
        catch(e => this.userAlreadyExist = false);

    }
  }

}
